import { lt } from '@mews/framework';
import { Option } from '@mews-commander/types';
import { GatewayPaymentMethod, PaymentMethods, PaymentRequestType } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { PaymentRequestFormField } from '../schema';
import { useGetPaymentRequestSupportedPaymentMethods } from '../../queries';

const paymentMethodsOptions: Record<GatewayPaymentMethod, Pick<Option, 'label' | 'value'>> = {
    [GatewayPaymentMethod.PaymentCard]: {
        label: lt('GeneralCardPlural'),
        value: PaymentMethods.PaymentCard,
    },
    [GatewayPaymentMethod.SepaDirectDebit]: {
        label: lt('SEPADirectDebit'),
        value: PaymentMethods.SepaDirectDebit,
    },
    [GatewayPaymentMethod.Ideal]: {
        label: lt('IDeal'),
        value: PaymentMethods.Ideal,
    },
    [GatewayPaymentMethod.ApplePay]: {
        label: lt('ApplePay'),
        value: PaymentMethods.ApplePay,
    },
    [GatewayPaymentMethod.GooglePay]: {
        label: lt('GooglePay'),
        value: PaymentMethods.GooglePay,
    },
};

export const PaymentRequestPaymentMethodsField = ({
    paymentRequestType,
}: {
    paymentRequestType: PaymentRequestType;
}) => {
    const { data: supportedPaymentMethods } = useGetPaymentRequestSupportedPaymentMethods({
        paymentRequestType,
    });
    const options = supportedPaymentMethods.map((method) => createOption(paymentMethodsOptions[method]));

    return (
        <SelectField
            name={PaymentRequestFormField.Methods}
            label={lt('ProcessPaymentPaymentRequestMethodsLabel')}
            helper={lt('ProcessPaymentPaymentRequestMethodsHelper')}
            multiselect
            required
            options={options}
            defaultValue={supportedPaymentMethods}
        />
    );
};
